const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/auth/api-factory');
const serviceFactory = require('../resources/auth/service-factory');
const messages = require('../utils/constants');
const PlatformConfig = require('../platform');
const apiVersionConfig = require('../appversion');

function parseJson(obj) {

  return JSON.stringify(obj);
}


function forceUpdateMessage() {

  let oReturn = {
    encryptionKeySuccess: false,
    encryptionMSG: messages["update-application-message"],
    type: "oldAppError"
  }
  return JSON.stringify(oReturn);

}




function getDummyEncryptionKey() {

  let oReturn = {
    encryptionKeySuccess: false,
    randomNum: messages["update-application-message"],
    publicKey: "",
    dummySesKey: "",
    encryptionMSG: ""
  }





  return JSON.stringify(oReturn);

}


function getAuthSuccess() {
  let oReturn = {
    authSuccess: true,
  }
  return JSON.stringify(oReturn);
}





function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/pbauthentication/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

    .match('app.version[{keys:ran_str}]', requests => Promise.all(
      requests.map(({ req, res }) => res.value(PlatformConfig.appVersion)
      )))

    .match(`${p}cache[{keys:ran_str}]`, requests => Promise.all(
      requests.map(({ req, res }) => res.value("true")
      )))

    .match(`app.config[{keys:ran_str}]`, requests => Promise.all(
      requests.map(({ req, res }) => {
        const result = Object.assign({}, apiConfig, apiVersionConfig);
        return res.value(JSON.stringify(result));
      }
      )))

    .match(`app.versionConfig[{keys:ran_str}]`, requests => Promise.all(
      requests.map(({ req, res }) => res.value(JSON.stringify(apiVersionConfig))
      )))

    .match('auth.pbOnlineEncryptionKey[{keys:userId}][{keys:type}][{keys:property}]', requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getEncryptionKey(req.params)
          .then(response => res.value(
            response[req.params.property] === undefined ? null : response[req.params.property]
          ))
          .catch(res.error)
      )))

    //for authHeader
    .match(`app.mAuth[{keys:authHeader}]`, requests => Promise.all(
      requests.map(({ req, res }) => res.value(getAuthSuccess())
      )))

    // create mockup 
    .match('auth.pbOnlineEncryptionJson[{keys:ran_str}][{keys:userId}][{keys:type}]', requests => Promise.all(
      requests.map(({ req, res }) => res.value(getDummyEncryptionKey())
      )))

    // Temporary fix for the  app update.. 
    .match('auth.pbOnlineEncryptionJson[{keys:userId}][{keys:type}]', requests => Promise.all(
      requests.map(({ req, res }) => res.value(forceUpdateMessage())
      )))

    .match(`${p}auth.pbOnlineChangePasswordEncryptionKey[{keys:userId}][{keys:type}][{keys:property}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getEncryptionKey(req.params)
          .then(response => res.value(
            response[req.params.property] === undefined ? null : response[req.params.property]
          ))
          .catch(res.error)
      )))

    .match(`${p}auth.pbOnlineChangePasswordEncryptionKeyJson[{keys:userId}][{keys:type}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getEncryptionKey(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)

      )))



    .match('auth.login[{keys:userId}][{keys:password}][{keys:dummySesKey}][{keys:property}]', requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getAuthentication(req.params)
          .then(response => res.value(
            response[req.params.property] === undefined ? null : response[req.params.property]
          ))
          .catch(res.error)
      )))
    .match('auth.loginJson[{keys:userId}][{keys:password}][{keys:dummySesKey}][{keys:deviceInfo}]', requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getAuthenticationWithDevice(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match('auth.loginJson[{keys:userId}][{keys:password}][{keys:dummySesKey}]', requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getAuthentication(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}auth.changePassword[{keys:password}][{keys:property}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.changePassword(req.params)
          .then(response => res.value(
            response[req.params.property] === undefined ? null : response[req.params.property]
          ))
          .catch(res.error)
      )))
    .match('auth.validateDevice[{keys:randomNum}][{keys:userId}][{keys:deviceId}][{keys:deviceToken}]'
      + '[{keys:property}]', requests => Promise.all(
        requests.map(({ req, res }) => res.value(forceUpdateMessage())
        )))
    .match('auth.validateDevice[{keys:randomNum}][{keys:deviceInfo}][{keys:userId}][{keys:deviceId}][{keys:deviceToken}]'
      + '[{keys:property}]', requests => Promise.all(
        requests.map(({ req, res }) => res.value(forceUpdateMessage())
        )))
    .match('auth.validateDeviceNewUI[{keys:randomNum}][{keys:userId}][{keys:deviceId}][{keys:deviceToken}]'
      + '[{keys:property}]', requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getDeviceValidation(req.params)
            .then(response => res.value(
              response[req.params.property] === undefined ? null : response[req.params.property]
            ))
            .catch(res.error)
        )))
    .match('auth.validateDeviceNewUI[{keys:randomNum}][{keys:deviceInfo}][{keys:userId}][{keys:deviceId}][{keys:deviceToken}]'
      + '[{keys:property}]', requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getDeviceValidationWithDevice(req.params)
            .then(response => res.value(
              response[req.params.property] === undefined ? null : response[req.params.property]
            ))
            .catch(res.error)
        )))

    .match('auth.validateDeviceBiometric[{keys:randomNum}][{keys:deviceInfo}][{keys:userId}][{keys:deviceId}][{keys:deviceToken}]', requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getDeviceValidationWithDeviceBiometric(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}auth.enrollDevice[{keys:userId}][{keys:deviceId}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getEnrollDevice(req.params)
          .then(response => res.value(response.deviceToken))
          .catch(res.error)
      )))
    .match(`${p}auth.disenrollDevice[{keys:userId}][{keys:deviceId}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getDisenrollDevice(req.params)
          .then(response => res.value(response.res))
          .catch(res.error)
      )));
}

module.exports = addRoutes;